// dashed suffixes that are not independent words
//  'flower-like', 'president-elect'
export default {
  'like': true,
  'ish': true,
  'less': true,
  'able': true,
  'elect': true,
  'type': true,
  'designate': true,
  // 'fold':true,
}